<!--
 * @Description: 
 * @Date: 2021-06-16 15:24:01
-->
<template>
  <div>
    <iframe
      :src="targetUrl1"
      ref="contract"
      scrolling="auto"
      frameborder="0"
      style="width: 100%;height: 850px;"
    ></iframe>
  </div>
</template>

<script>
import myDialogMixin from '@/components/myDailog/myDialogMixin';
export default {
  name: 'openIframe',
  mixins: [myDialogMixin],
  props: {
    //todo 要删掉连接,
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    targetUrl: { type: String, default: '' }
  },
  data() {
    return {
      targetUrl1: ''
    };
  },
  mounted() {
    // console.log(this.options, 2222);
    let { url } = this.options;
    this.targetUrl1 = url;
    // this.url
  }
};
</script>

<style scoped></style>
